import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const CreateTagButton = styled.div`
    width: 196px;
    height: 46px;
    background-color: #151514;
    color: #fff;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    border-radius: 3px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        width: 136px;
        height: 36px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        width: 100%;
        height: 36px;
    }
`;

export const CreateTagWrapper = styled(FlexBox)`
    margin-top: 40px;
    flex-flow: column;
    width: 100%;
    max-width: 1152px;
    z-index: 100;

    .geo-input input {
        padding-left: 44px;
    }

    .search-wrapper_second, .search-wrapper {
        height: 48px !important;
    }

    .input-text input, .input-wrapper {
        width: 100%;
        background-color: rgba(242, 242, 242, 1);
        color: #151514;
        outline: none;
        border-radius: 3px;
        height: 48px !important;
        border: 1px solid transparent;

        &::placeholder {
            color: rgba(182, 182, 181, 1);
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
        }

        &:focus, &:active {
            border: 1px solid #151514;
            border-radius: 3px;
        }

        &:hover {
            &::placeholder {
                color: rgba(182, 182, 181, 1);
                font-size: 17px;
                line-height: 22px;
                font-weight: 400;
            }
        }
    }

    .input-wrapper {

        input {
            ::placeholder {
                color: rgba(182, 182, 181, 1);
                font-size: 17px;
                line-height: 22px;
                font-weight: 400;
            }
        }
        &:hover {
            border: 1px solid #151514;
        }
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 100%;
    }
`;

export const CreateTagModalWrapper = styled(CreateTagWrapper)`
    max-width: 1152px;
`;

export const PersonalizedTagWrapper = styled(CreateTagWrapper)`
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;

    @media(max-width: ${LayoutConst.screen.sm}px) {
        padding-left: 10px;
        padding-right: 10px;
    }
`;

export const PersonalizedTagModalWrapper = styled(CreateTagModalWrapper)`
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;

    @media(max-width: ${LayoutConst.screen.sm}px) {
        padding-left: 10px;
        padding-right: 10px;
    }
`;

export const ContentContainer = styled(FlexBox)`
    width: 100%;
    flex-flow: row;
    gap: 24px;
    align-items: flex-start;

    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column;
        gap: 16px;
    }
`;

export const ImageBlock = styled(FlexBox)`
    flex-shrink: 0;
    width: 270px;
    flex-flow: column;

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        width: 204px;
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const ImageBlockPlaceholder = styled(FlexBox)`
    width: 270px;
    height: 270px;
    background: rgba(242, 242, 242, 1);
    border-radius: 3px;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    text-align: center;
    padding: 24px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
        background: rgba(231, 231, 231, 1);
    }

    img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        pointer-events: none;
        z-index: 0;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        width: 204px;
        height: 204px;
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {
        width: 100%;
        height: 300px;
    }
`;

export const ImageFileInput = styled.input`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
    display: block !important;
`;

export const ImagePlaceholderTitle = styled.span`
    width: 186px;
    color: ${Colors.galBlack47};
    text-align: center;
    font-family: Inter, sans-serif;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
`;

export const ImagePlaceholderFormat = styled.span`
    color: ${Colors.galBlack47};
    text-align: center;
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin-top: 8px;
`;

export const FieldsColumn = styled(FlexBox)`
    flex: 1;
    min-width: 0;
    width: 100%;
    flex-flow: column;
    gap: 24px;

    @media(max-width: ${LayoutConst.screen.sm}px) {
        gap: 16px;
    }
`;

export const Title = styled(FlexBox)`
    font-size: 30px;
    line-height: 33px;
    font-weight: 600;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 23px;
        line-height: 27px;
        font-weight: 600;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 20px;
        line-height: 25px;
        font-weight: 600;
    }
`;

export const Label = styled.span<{ mb?: number }>`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
    margin-bottom: ${({ mb }) => mb ? `${mb}px` : '12px'};

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 13px;
        line-height: 16px;
    }

`;

export const ImageLabel = styled.span`
    font-size: 15px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
    margin-bottom: 6px;
`;

export const ImageDeleteButton = styled.button`
    position: absolute;
    top: 12px;
    right: 16px;
    width: 40px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 4px;
    box-sizing: border-box;
    background: rgba(24, 26, 28, 0.4);
    backdrop-filter: blur(4px);
    cursor: pointer;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
`;

export const SubmitButton = styled.button`
    width: 127px;
    height: 36px;
    background-color: #151514;
    color: #fff;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    border-radius: 3px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    border-color: transparent;

    &:disabled {
        background-color: rgba(231, 231, 231, 1);
        color: rgba(182, 182, 181, 1);
        pointe-events: none;
        cursor: normal;
    }
`;

export const PersonalizedHeader = styled(FlexBox)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;

    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
        margin-bottom: 24px;

        ${Title} {
            width: 100%;
        }

        & > *:not(${Title}) {
            width: 100%;
        }

        ${SubmitButton} {
            width: 100%;
        }
    }
`;

export const PointResultContainer = styled(FlexBox)`
    width: 100%;
    height: auto;
    flex-flow: column;

    .point-item {
        &:hover {
            background-color: #e7e7e7;

            * {
                background-color: #e7e7e7;
                transition: background-color 0.2s;
            }
        }
    }

`;

export const CloseIconWrapper = styled(FlexBox)<{ hide?: boolean, collapse?: boolean }>`
    position: absolute;
    bottom: 15.5px;
    right: 16px;
    cursor: pointer;
    ${({ hide }) => hide && css`
        visibility: hidden;
    `};

    ${({ collapse }) => collapse && css`
        bottom: 0;
        top: 47px;
    `};

    svg path {
        fill: rgba(144, 144, 144, 1);
        transition: fill 0.2s;
    }

    svg {
        :hover {
            path {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }
`;

export const SearchIconWrapper = styled(FlexBox)<{ collapse?: boolean }>`
    position: absolute;
    bottom: 15.5px;
    left: 16px;
    z-index: 99;

    ${({ collapse }) => collapse && css`
        bottom: 0;
        top: 50px;
    `};

    svg path {
        fill: rgba(144, 144, 144, 1);
        transition: fill 0.2s;
    }
`;import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const CreateTagButton = styled.div`
    width: 196px;
    height: 46px;
    background-color: #151514;
    color: #fff;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    border-radius: 3px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        width: 136px;
        height: 36px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        width: 100%;
        height: 36px;
    }
`;

export const CreateTagWrapper = styled(FlexBox)`
    margin-top: 40px;
    flex-flow: column;
    width: 100%;
    max-width: 1152px;
    z-index: 100;

    .geo-input input {
        padding-left: 44px;
    }

    .search-wrapper_second, .search-wrapper {
        height: 48px !important;
    }

    .input-text input, .input-wrapper {
        width: 100%;
        background-color: rgba(242, 242, 242, 1);
        color: #151514;
        outline: none;
        border-radius: 3px;
        height: 48px !important;
        border: 1px solid transparent;

        &::placeholder {
            color: rgba(182, 182, 181, 1);
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
        }

        &:focus, &:active {
            border: 1px solid #151514;
            border-radius: 3px;
        }

        &:hover {
            &::placeholder {
                color: rgba(182, 182, 181, 1);
                font-size: 17px;
                line-height: 22px;
                font-weight: 400;
            }
        }
    }

    .input-wrapper {

        input {
            ::placeholder {
                color: rgba(182, 182, 181, 1);
                font-size: 17px;
                line-height: 22px;
                font-weight: 400;
            }
        }
        &:hover {
            border: 1px solid #151514;
        }
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 100%;
    }
`;

export const CreateTagModalWrapper = styled(CreateTagWrapper)`
    max-width: 1152px;
`;

export const PersonalizedTagWrapper = styled(CreateTagWrapper)`
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;

    @media(max-width: ${LayoutConst.screen.sm}px) {
        padding-left: 10px;
        padding-right: 10px;
    }
`;

export const PersonalizedTagModalWrapper = styled(CreateTagModalWrapper)`
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;

    @media(max-width: ${LayoutConst.screen.sm}px) {
        padding-left: 10px;
        padding-right: 10px;
    }
`;

export const ContentContainer = styled(FlexBox)`
    width: 100%;
    flex-flow: row;
    gap: 24px;
    align-items: flex-start;

    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column;
        gap: 16px;
    }
`;

export const ImageBlock = styled(FlexBox)`
    flex-shrink: 0;
    width: 270px;
    flex-flow: column;

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        width: 204px;
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const ImageBlockPlaceholder = styled(FlexBox)`
    width: 270px;
    height: 270px;
    background: rgba(242, 242, 242, 1);
    border-radius: 3px;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    text-align: center;
    padding: 24px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
        background: rgba(231, 231, 231, 1);
    }

    img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        pointer-events: none;
        z-index: 0;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        width: 204px;
        height: 204px;
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {
        width: 100%;
        height: 300px;
    }
`;

export const ImageFileInput = styled.input`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
    display: block !important;
`;

export const ImagePlaceholderTitle = styled.span`
    width: 186px;
    color: ${Colors.galBlack47};
    text-align: center;
    font-family: Inter, sans-serif;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
`;

export const ImagePlaceholderFormat = styled.span`
    color: ${Colors.galBlack47};
    text-align: center;
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin-top: 8px;
`;

export const FieldsColumn = styled(FlexBox)`
    flex: 1;
    min-width: 0;
    width: 100%;
    flex-flow: column;
    gap: 24px;

    @media(max-width: ${LayoutConst.screen.sm}px) {
        gap: 16px;
    }
`;

export const Title = styled(FlexBox)`
    font-size: 30px;
    line-height: 33px;
    font-weight: 600;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 23px;
        line-height: 27px;
        font-weight: 600;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 20px;
        line-height: 25px;
        font-weight: 600;
    }
`;

export const Label = styled.span<{ mb?: number }>`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
    margin-bottom: ${({ mb }) => mb ? `${mb}px` : '12px'};

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 13px;
        line-height: 16px;
    }

`;

export const ImageLabel = styled.span`
    font-size: 15px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
    margin-bottom: 6px;
`;

export const ImageDeleteButton = styled.button`
    position: absolute;
    top: 12px;
    right: 16px;
    width: 40px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 4px;
    box-sizing: border-box;
    background: rgba(24, 26, 28, 0.4);
    backdrop-filter: blur(4px);
    cursor: pointer;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
`;

export const SubmitButton = styled.button`
    width: 127px;
    height: 36px;
    background-color: #151514;
    color: #fff;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    border-radius: 3px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    border-color: transparent;

    &:disabled {
        background-color: rgba(231, 231, 231, 1);
        color: rgba(182, 182, 181, 1);
        pointe-events: none;
        cursor: normal;
    }
`;

export const PersonalizedHeader = styled(FlexBox)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;

    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
        margin-bottom: 24px;

        ${Title} {
            width: 100%;
        }

        & > *:not(${Title}) {
            width: 100%;
        }

        ${SubmitButton} {
            width: 100%;
        }
    }
`;

export const PointResultContainer = styled(FlexBox)`
    width: 100%;
    height: auto;
    flex-flow: column;

    .point-item {
        &:hover {
            background-color: #e7e7e7;

            * {
                background-color: #e7e7e7;
                transition: background-color 0.2s;
            }
        }
    }

`;

export const CloseIconWrapper = styled(FlexBox)<{ hide?: boolean, collapse?: boolean }>`
    position: absolute;
    bottom: 15.5px;
    right: 16px;
    cursor: pointer;
    ${({ hide }) => hide && css`
        visibility: hidden;
    `};

    ${({ collapse }) => collapse && css`
        bottom: 0;
        top: 47px;
    `};

    svg path {
        fill: rgba(144, 144, 144, 1);
        transition: fill 0.2s;
    }

    svg {
        :hover {
            path {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }
`;

export const SearchIconWrapper = styled(FlexBox)<{ collapse?: boolean }>`
    position: absolute;
    bottom: 15.5px;
    left: 16px;
    z-index: 99;

    ${({ collapse }) => collapse && css`
        bottom: 0;
        top: 50px;
    `};

    svg path {
        fill: rgba(144, 144, 144, 1);
        transition: fill 0.2s;
    }
`;